import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';
import { roleKeySchema } from './enums.js';
import { twoFactorMethodSchema } from './security.js';
export const loginRequestSchema = z.object({
    email: z.string().trim().toLowerCase().email().max(200),
    password: z.string().min(8).max(200),
    /** Nur nötig, wenn dieselbe E-Mail in mehreren Mandanten existiert. */
    tenantSlug: z.string().trim().min(1).max(60).optional(),
});
export const authenticatedUserSchema = z.object({
    id: idSchema,
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    displayName: z.string(),
    locale: z.string(),
    tenantLocale: z.string(),
    avatarUrl: z.string().nullable(),
    tenantId: idSchema,
    tenantName: z.string(),
    tenantSlug: z.string(),
    roleKey: roleKeySchema,
    roleName: z.string(),
    permissions: z.array(z.string()),
    isTwoFactorEnabled: z.boolean(),
    twoFactorMethods: z.array(twoFactorMethodSchema),
    primaryTwoFactorMethod: twoFactorMethodSchema.nullable(),
    emailVerifiedAt: isoDateTimeSchema.nullable(),
    forcePasswordChange: z.boolean(),
    lastLoginAt: isoDateTimeSchema.nullable(),
});
export const loginResponseSchema = z.object({
    user: authenticatedUserSchema,
    /** Sekunden bis zum Ablauf des Access-Tokens; das Token selbst liegt im httpOnly-Cookie. */
    expiresInSeconds: z.number().int().positive(),
});
/** Antwort der Anmeldung: entweder fertige Sitzung oder Aufforderung zum zweiten Faktor. */
export const loginOutcomeSchema = z.union([
    loginResponseSchema.extend({ twoFactorRequired: z.literal(false) }),
    z.object({
        twoFactorRequired: z.literal(true),
        challengeToken: z.string(),
        expiresInSeconds: z.number().int().positive(),
        methods: z.array(twoFactorMethodSchema).min(1),
        primaryMethod: twoFactorMethodSchema,
        maskedEmail: z.string().optional(),
        resendAvailableInSeconds: z.number().int().min(0).optional(),
    }),
]);
export const sessionResponseSchema = z.object({
    user: authenticatedUserSchema,
});
//# sourceMappingURL=auth.js.map